import { Outlet, createFileRoute } from '@tanstack/react-router';

/** Layout for `/register` and legacy `/register/$item/$token` email verify. */
export const Route = createFileRoute('/register')({
  component: RegisterLayout,
});

function RegisterLayout() {
  return <Outlet />;
}
